export const CSS_ZINDEX_DRAWER = 1000;
export const CSS_ZINDEX_NAVIGATOR_TABS = 202;
export const CSS_ZINDEX_MODEL_VIEWER_TOGGLE = 201;
export const CSS_ZINDEX_MODEL_VIEWER = 200;

/**
 * Default deadline (in whole hours) for newly created order types. Mirrors
 * the `order_types.deadline_duration_seconds` column default in the database
 * (see `hickory/migrations/0001_alter/2026-05-09.sql`). Keep these in sync.
 */
export const DEFAULT_DEADLINE_HOURS = 16;

export type PermissionLevel = 100 | 300 | 600 | 900;

export const PERMISSION_LEVEL_ADMIN = 900;
export const PERMISSION_LEVEL_EDIT = 600;
export const PERMISSION_LEVEL_VIEW = 300;
export const PERMISSION_LEVEL_EXTERNAL = 100;

export const PERMISSION_LEVELS = [
  PERMISSION_LEVEL_EXTERNAL,
  PERMISSION_LEVEL_VIEW,
  PERMISSION_LEVEL_EDIT,
  PERMISSION_LEVEL_ADMIN,
] as const;
